"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomPagination = CustomPagination;
const react_1 = __importDefault(require("react"));
const Pagination_1 = __importDefault(require("./Pagination"));
function CustomPagination({ nbPages, page, perPage, onChange, label }) {
    if (parseInt(nbPages) <= 0)
        return null;
    return (react_1.default.createElement("div", { className: "d-flex align-items-baseline justify-content-between custom-paginate-padding" },
        react_1.default.createElement("div", { className: "footer-form d-flex align-items-center gap-2 mt-3" },
            react_1.default.createElement("div", { className: "footer-form-label" }, label),
            react_1.default.createElement("select", { className: "select-perpage", name: "limit", id: "limit", value: perPage, onChange: (e) => {
                    onChange(1, parseInt(e.target.value, 10));
                } },
                react_1.default.createElement("option", { value: "10" }, "10"),
                react_1.default.createElement("option", { value: "30" }, "30"),
                react_1.default.createElement("option", { value: "50" }, "50"),
                react_1.default.createElement("option", { value: "100" }, "100"))),
        parseInt(nbPages) > 0 ? (react_1.default.createElement(Pagination_1.default, { page: page, total: nbPages / perPage, perPage: perPage, onPageChange: (page) => onChange(page, perPage) })) : null));
}
